import { hasPermission } from 'v2/context/permissionFlagContext';
import { Permission, Role } from 'v2/models';
import { PERMISSION_NAME } from 'v2/utils/permissions';

export const getNotificationEditPerms = (
  role: Role,
  permissions: { [key: string]: Permission }
) => {
  const isReviewSearchOrg = hasPermission(
    Object.values(permissions),
    [
      PERMISSION_NAME.REVIEW_SEARCH_ORG,
      PERMISSION_NAME.REVIEW_SEARCH_MASTER_ORG,
    ],
    true
  );

  const isOwnLevelPermissionActive = Object.values(permissions).some(
    (item) =>
      ['create-search-own', 'create-search-internal-won'].includes(
        item?.permission_name
      ) && item?.subscription_active
  );

  const isEnterpriseActive = Object.values(permissions).some(
    (item) => item?.plan_family === 'enterprise'
  );

  const canEditNewInvoice = role === 'dataBuyer' && !isEnterpriseActive;

  return {
    canEditEmailUser: true,
    canEditEmailOrg: !isOwnLevelPermissionActive,
    canEditNewForReviewSearches: isReviewSearchOrg,
    canEditNewProviderResponseForReviewedRequests: isReviewSearchOrg,
    canEditNewInvoice,
  };
};
